import { withResolvers } from './utils.js';
export const createWebsiteModule = ({ createHost, }) => {
    return {
        __type: 'host',
        create: (_host) => {
            // Here we can implement module methods that could be used by the SDK via "wixClient.use(website)" api.
            // We don't have any for now, so we just return an empty object.
            return {};
        },
        host: (options) => {
            const { applicationId } = options ?? {};
            const wixEmbedsAPI = typeof window !== 'undefined' ? window.wixEmbedsAPI : undefined;
            const host = createHost(options);
            const apiBaseUrl = getApiBaseUrl();
            return {
                ...host,
                apiBaseUrl,
                getMonitoringClient: wixEmbedsAPI?.getMonitoringClientFunction?.(applicationId),
                essentials: {
                    language: typeof window !== 'undefined'
                        ? window.commonConfig?.language
                        : undefined,
                    locale: typeof window !== 'undefined'
                        ? window.commonConfig?.locale
                        : undefined,
                },
            };
        },
        auth: (getAccessTokenFn) => {
            const wixEmbedsAPI = typeof window !== 'undefined' ? window.wixEmbedsAPI : undefined;
            if (!getAccessTokenFn) {
                /*
                We must call wixEmbedsAPI.getAccessTokenFunction() in the main frame and not from async callbacks / setTimeout calls
                since it uses document.currentScript API behind the scenes
                https://developer.mozilla.org/en-US/docs/Web/API/Document/currentScript
                * */
                getAccessTokenFn = wixEmbedsAPI?.getAccessTokenFunction?.();
            }
            let injectorCreated = false;
            const { resolve: resolveAccessTokenFn, promise: accessTokenFnPromise } = withResolvers();
            return {
                getAuthHeaders: async () => {
                    if (!getAccessTokenFn && injectorCreated) {
                        getAccessTokenFn = await accessTokenFnPromise;
                    }
                    if (!getAccessTokenFn) {
                        throw new Error('Failed to resolve auth token');
                    }
                    return {
                        headers: {
                            Authorization: await getAccessTokenFn(),
                        },
                    };
                },
                getAccessTokenInjector: () => {
                    injectorCreated = true;
                    return (_getAccessTokenFn) => {
                        resolveAccessTokenFn(_getAccessTokenFn);
                    };
                },
            };
        },
    };
};
function getApiBaseUrl() {
    const wixEmbedsAPI = typeof window !== 'undefined' ? window.wixEmbedsAPI : undefined;
    const apiBaseUrl = wixEmbedsAPI?.getExternalBaseUrl?.();
    if (!apiBaseUrl) {
        return;
    }
    // clean the protocol from the URL
    const parsedUrlObject = new URL(apiBaseUrl);
    if (parsedUrlObject?.pathname && parsedUrlObject.pathname !== '/') {
        return `${parsedUrlObject.hostname}${parsedUrlObject.pathname}`;
    }
    return parsedUrlObject.hostname;
}
//# sourceMappingURL=websiteHostModule.js.map